const dekstopStyle = {
    mountStyle: {
        position: "absolute",
        top: 0,
        width: "100%"
        // left: "15px",
        // right: "15px"
    },
    animateInStyle: {
        position: "absolute",
        top: "-100%",
        transition: "all .3s ease-in-out",
        width: "100%"
    },
    currentStyle: {
        position: "relative"
    },
    defaultStyle: {
        minHeight: "450px",
        maxHeight: "450px",
        marginTop: "35px"
    },
    visibilityHidden: {
        visibility: "hidden"
    },
    visibilityShown: {
        visibility: "visible"
    }
};
const dekstopLandingLeadStyle = {
    mountStyle: {
        position: "relative"
    },
    currentStyle: {
        position: "relative"
    },
    visibilityHidden: {
        display: "none"
    },
    visibilityShown: {
        display: "block"
    }
};
const mobileStyle = {
    mountStyle: {
        position: "relative",
        right: "-110%"
    },
    animateInStyle: {
        position: "relative",
        right: 0,
        transition: "all .3s ease-in-out"
    }
};

export {
    dekstopLandingLeadStyle,
    dekstopStyle,
    mobileStyle
};
